module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/niagara-falls-567f0ccb97e8e3f3f7e4f8d153150508.png";